import React from 'react'

import Layout from '../components/Layout'
import Hero from '../components/Hero'
import About from '../components/About'
import Mission from '../components/Mission'
import Vission from '../components/Vission'
import Services from '../components/Services'
import Benefits from '../components/Benefits'
import Contact from '../components/Contact'

function IndexPage() {
	return (
		<Layout>
			<Hero />
			<About />
			<Mission />
			<Vission />
			<Services />
			<Benefits />
			<Contact />
		</Layout>
	)
}

export default IndexPage
